import React from 'react'

const AnalyticsMenu = ({buttons, testInstanceMode}) => {
    return (
        <div className="analytics-sections-nav row">
            { 
                buttons.map(button => {
                    const className = `btn btn-analytics-nav ${testInstanceMode === button.mode || testInstanceMode === 'Both' ? "" : "btn-analytics-nav-unactivated" }`
                    const onClick = () => testInstanceMode === button.mode || testInstanceMode === 'Both' ? button.onClick() : null

                    return <button
                        type="button"
                        className={className}
                        onClick={onClick}
                    >
                    { button.name }
                  </button>
                })
            }
        </div>
      );
}

export default AnalyticsMenu